import { render, staticRenderFns } from "./RecordNotificationModal.vue?vue&type=template&id=87b6de74&scoped=true&"
import script from "./RecordNotificationModal.vue?vue&type=script&lang=js&"
export * from "./RecordNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./RecordNotificationModal.vue?vue&type=style&index=0&id=87b6de74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b6de74",
  null
  
)

export default component.exports